module.exports = __webpack_public_path__ + "static/textarea-placeholder-dont-b8a11365d5f6013cf38c618631b8a69d.png";